import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";
import PageHeader from "@/components/PageHeader";
import { SERVICES } from "@/lib/siteData";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHeader
        eyebrow="— Services"
        title="Everything from a single bucket of dirt to a fully shaped paddock."
        intro="Nine specialist services across rural, agricultural and residential earthworks. Tell us what you've got planned — we'll tell you how we'd approach it."
      />

      <section className="section-pad bg-[#F6F5F2]">
        <div className="container-fz space-y-px bg-[#D2D0C9] border border-[#D2D0C9]">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.slug}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              data-testid={`service-row-${s.slug}`}
              className="bg-[#F6F5F2] hover:bg-white transition-colors p-8 md:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8"
            >
              <div className="lg:col-span-2">
                <span className="num-marker">0{i + 1}</span>
              </div>
              <div className="lg:col-span-5">
                <h2 className="font-display text-2xl md:text-3xl lg:text-4xl text-stone-900 leading-tight">
                  {s.title}
                </h2>
                <p className="mt-5 text-stone-600 leading-relaxed">{s.summary}</p>
              </div>
              <div className="lg:col-span-5">
                <ul className="space-y-3">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3">
                      <CheckCircle
                        size={20}
                        weight="duotone"
                        className="text-[#D05322] shrink-0 mt-1"
                      />
                      <span className="text-stone-700">{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="container-fz mt-16 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <p className="text-stone-600 max-w-xl">
            Got a project that doesn't quite fit the list? Most of it's still
            our bread and butter — flick us a message and we'll let you know.
          </p>
          <Link to="/contact" data-testid="services-contact-link" className="btn-primary">
            Request a quote <ArrowRight size={16} weight="bold" />
          </Link>
        </div>
      </section>
    </div>
  );
}
